import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useSkills } from "routes/@lib/skills"
import { createTailoredAuditReason, updateTailoredAuditReason } from "lib/@offline/queued-audits"
import { formatCreateTailoredAudit } from "./lib/format-create-tailored-audit"
import { EditAuditReason } from "./edit-audit-reason"

export function EditJustification() {
    const {
        justification,
        setJustification,
        tailoringReferenceId,
        schedule,
        scheduleItem,
        originalTask,
        tailoredTask,
        tailoringAudit,
        pendingChange,
    } = useBoundContext()

    const [skills] = useSkills()

    return (
        <EditAuditReason
            value={justification}
            setValue={setJustification}
            label="Add justification"
            disabled={pendingChange}
            tailoringAudit={tailoringAudit}
            hasExistingReason={Boolean(tailoringAudit?.payload?.reason)}
            dataCy="edit-justification-text-field"
            onBuildAudit={createAudit}
            onUpdateExisting={updateTailoredAuditReason}
            onCreate={createTailoredAuditReason}
            type="justification"
        />
    )

    function createAudit(reason) {
        return formatCreateTailoredAudit({
            originalTask,
            tailoredTask,
            tailoringReferenceId,
            schedule,
            scheduleItem,
            reason,
            skills,
        })
    }
}
